import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FullScreenLoader } from '@/components/ui/full-screen-loader';
import { isCookieYesLoaded, markProtectedContentShown } from '@/lib/consent/cookieYes';
import { useEffect } from 'react';
/**
 * Wraps every screen that shows clinical data (ProtectedRoute, the share-link viewer, the Link
 * app, the emailed-report landing) so the third-party consent banner never runs alongside it.
 *
 * The banner script loads on the public sign-in pages, and signing in is a client-side
 * navigation, so the script would still be running when the worklist mounts. When it is, this
 * renders only a loader and reloads the same URL: the fresh document restores the session from
 * the refresh cookie and never loads the banner. Otherwise it marks the document as having shown
 * clinical data, which stops the sign-in page (after a logout) from loading the banner into it.
 */
export function ConsentScriptBoundary({ children }) {
    const bannerRunning = isCookieYesLoaded();
    useEffect(() => {
        if (bannerRunning)
            window.location.reload();
    }, [bannerRunning]);
    if (bannerRunning)
        return _jsx(FullScreenLoader, {});
    // During render, not in an effect: the mark must be in place before any child mounts.
    // Idempotent, so StrictMode's double render is harmless.
    markProtectedContentShown();
    return _jsx(_Fragment, { children: children });
}
